import React, { Component } from 'react';
import {
  Col,
  Row
} from '../../../shared/packages/Grid';
import contentProvider from '../../../redux/modules/contentProvider/contentProvider';

class Footer extends Component {
  render() {
    return (
        <div aria-label="Footer" role="footer" className="mp-footer">
            <Row className="flex-align-center centered-column no-margin">
              <Col xs={12}>
                <p className="text-center x-body3">
                  {String.fromCharCode(169)} {contentProvider.getValue(`myplanFooter.copyrightYear`)} Comcast
                </p>
              </Col>
            </Row>
        </div>
    );
  }
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./client/components/Common/Footer/Footer.jsx
 **/